import * as yup from 'yup';
import {
  validateDate,
  validateForHebrew,
  validatePhoneNumber,
  validateForIsraeliID,
} from '../../../../../utils/validationHelpers';

export const createTravelerValidationSchema = ({
  travelerCount,
  policyHolderMinDOB,
  policyHolderMaxDOB,
  messages,
}) => {
  const validation = {
    isLeftIsrael: yup.boolean().oneOf([true], messages('validation.required')),
    phone1: validatePhoneNumber(),
  };

  for (let index = 0; index < travelerCount; index += 1) {
    const fieldNumber = index + 1;
    const otherIdFields = Array.from({length: travelerCount}, (_, otherIndex) => otherIndex)
      .filter(otherIndex => otherIndex !== index)
      .map(otherIndex => yup.ref(`ID${otherIndex + 1}`));

    validation[`ID${fieldNumber}`] = validateForIsraeliID().notOneOf(
      otherIdFields,
      messages('validation.unique'),
    );
    validation[`dob${fieldNumber}`] = validateDate(policyHolderMinDOB, policyHolderMaxDOB, 'תאריך לא תקין');
    validation[`firstName${fieldNumber}`] = validateForHebrew(messages('validation.firstNameHebrew'));
    validation[`lastName${fieldNumber}`] = validateForHebrew(messages('validation.lastNameHebrew'));
    validation[`gender${fieldNumber}`] = yup.string().typeError().required(messages('validation.required'));
  }

  return validation;
};